import { render, staticRenderFns } from "./GeolocationGuide.vue?vue&type=template&id=90c0bb60&scoped=true"
import script from "./GeolocationGuide.vue?vue&type=script&lang=js"
export * from "./GeolocationGuide.vue?vue&type=script&lang=js"
import style0 from "./GeolocationGuide.vue?vue&type=style&index=0&id=90c0bb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c0bb60",
  null
  
)

export default component.exports